var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83343 9.83343C10.0555 9.61134 10.0555 9.25125 9.83343 9.02916L7.92387 7.1196C7.66553 6.86125 7.64426 6.4547 7.81809 6.13335C8.1359 5.54581 8.3164 4.87314 8.3164 4.1582C8.3164 1.86159 6.4548 0 4.1582 0C1.86159 0 0 1.86159 0 4.1582C0 6.4548 1.86159 8.3164 4.1582 8.3164C4.87314 8.3164 5.54581 8.1359 6.13335 7.81809C6.4547 7.64426 6.86125 7.66553 7.11959 7.92387L9.02916 9.83343C9.25125 10.0555 9.61134 10.0555 9.83343 9.83343ZM1.13729 4.1582C1.13729 2.49243 2.49243 1.13729 4.1582 1.13729C5.82397 1.13729 7.17911 2.49243 7.17911 4.1582C7.17911 5.82397 5.82397 7.17911 4.1582 7.17911C2.49243 7.17911 1.13729 5.82397 1.13729 4.1582Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.54140d48e0c5a996df307cb03c5034c8.svg";
export { ForwardRef as ReactComponent };